interface Props {
  isLoggedIn: boolean;
  isMember: boolean;
  isNewEmail: boolean;
}

const WelcomeComponent = (props: Props) => {
  let isLoggedIn = props.isLoggedIn;
  let isMember = props.isMember;
  let isNewEmail = props.isNewEmail;

  return (<>
    {isLoggedIn ? (<>
      <p className="lead">You may subscribe or unsubscribe to any of our message categories which are displayed below. Please allow up to 48 hours for your changes to take effect.</p>
      <p className="lead">
        {!isMember && (<>
          To complete your account creation request,{" "}
          <a href="https://my.raps.org/account/login.aspx?forgot=yes&RedirectUrl=https%3a%2f%2fwww.raps.org%2f%3fAction%3dLogout?reload=timezone">click here to reset your password</a> created by
          the system.{" "}
        </>)}
        Let us know more about you by updating your <a href="https://www.raps.org/member-dashboard/professional-profile">professional profile</a>.
      </p>
    </>) : isNewEmail ? (<>
      
    </>) : (<>
      <p className="lead">
        Please enter your e-mail address below or
        <a href="/login?returnUrl=%2Fpreferences">log in to your account.</a>
        Please note that some communications categories will only be available when logged in to your account. Please allow up to 48 hours for your changes to take effect.
      </p>
    </>)}
  </>);
};

export default WelcomeComponent;